import React from 'react'
import { GrayWrapper, ValueView } from './style'
import LoadingBar from '../../components/LoadingBar'

interface FeeValuesProps {
  exchangeRate: string
  fee: string
  isLoading: boolean

}
const FeeValues = ({ exchangeRate, fee, isLoading }: FeeValuesProps): JSX.Element => {
  return (
    <GrayWrapper style={{ flexDirection: 'column' }}>
      <ValueView>
        <span>Exchange Rate</span>
        {isLoading
          ? (
            <LoadingBar style={{ height: 15.5, width: 150 }}/>
          )
          : (
            <span>{exchangeRate}</span>
          )}
      </ValueView>
      <ValueView>
        <span>Fee</span>
        {isLoading
          ? (
            <LoadingBar style={{ height: 15.5, width: 100 }}/>
          )
          : (
            <span>{fee}</span>
          )}
      </ValueView>
    </GrayWrapper>
  )
}

export default FeeValues